<template>
  <li class="cell">
    <a @click="$router.push(`/partners/${partner.id}`)" class="cell-container">
      <div class="cell-content">
        <div v-if="partner.featured_image" class="cell-img" :style="'background-image:url(' + encodeURI(partner.featured_image.url) + ')'"></div>
        <div class="cell-fields">
          <p v-if="partner.tour_side && partner.tour_side !== 'Unassigned'" class="tour-side">{{partner.tour_side}}</p>
          <span class="cell-title"><template v-if="partner.tour_number">{{partner.tour_number}}. </template><template>{{partner.business_name}}</template></span>
          <p v-if="partner.tour_address" class="cell-address">{{partner.tour_address}} {{partner.tour_address_2}} {{partner.tour_city}} {{partner.tour_zip}}</p>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
export default {
  props: ['partner'],
}
</script>

<style scoped lang="less">
@import '../css/variables';

.cell {
  position: relative;
  overflow: hidden;
  padding-left: 20px;
}

.cell-content {
  position: relative;
  display: flex;
  align-items: center;
  padding: 20px 20px 20px 0;
  transform: translateX(0);
  color: #000;
  text-decoration: none;
  background-color: #fff;
  border-bottom: 1px solid #EBEBEB;
  z-index: 2;
  &:active {
    background-color: #f5f5f5;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -20px;
      width: 20px;
      height: 100%;
      background: #f5f5f5;
    }
  }
  p {
    margin-bottom: 10px;
    overflow: hidden;
    font-size: 15px;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.cell-address {
      margin: 5px 0;
    }
    &.tour-side {
      margin-bottom: 2px;
      font-size: 13px;
      font-weight: bold;
      text-transform: uppercase;
      color: @themeColor1;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .cell-img {
    min-width: 61px;
    height: 61px;
    background-size: cover;
    background-position: center;
    background-color: #1e1e1e;
    border-radius: 61px;
    margin-right: 13px;
  }
  .cell-fields {
    max-width: calc(~'100% - 74px');
    .cell-title {
      display: block;
      overflow: hidden;
      font-size: 25px;
      font-weight: bold;
      line-height: 33px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CellPartner.vue